import { AppElement, html } from '../AppElement.js';
import TopPickup from './TopPickup';
import TopPickupCard from './TopPickupCard';
import ColorArray from '../ColorArray';

const NAME_ROOMS = 'Rooms';
const NAME_ADR = 'ADR';
const NAME_REVENUE = 'Revenue';
const NUM_TOPS = 3;

export default class TopPickupHotelCardList extends AppElement {
    static get properties() {
        return {
            hotel: { type: Object },
            recordDate: { type: String },
            pickupSetting: { type: Number },
            topPickupCards: { type: Array }
        };
    }

    constructor(props = {}) {
        super();

        this.hotel = props.hotel;
        this.recordDate = props.recordDate;
        this.pickupSetting = props.pickupSetting;
        this.topPickupCards = props.topPickupCards;

        this.colorArray = (new ColorArray());

        if (!Array.isArray(this.topPickupCards)) {
            this.topPickupCards = [];
            this.obtainRoomsCard();
            this.obtainAdrCard();
            this.obtainRevenueCard();
        }
    }

    reflow(props = {}) {
        this.hotel = props.hotel || this.hotel;
        this.recordDate = props.recordDate || this.recordDate;
        this.pickupSetting = props.pickupSetting || this.pickupSetting;
        this.topPickupCards = props.topPickupCards || this.topPickupCards;

        if (!Array.isArray(this.topPickupCards)) {
            this.topPickupCards = [];
            this.obtainRoomsCard();
            this.obtainAdrCard();
            this.obtainRevenueCard();
        }

        this.fill();
    }

    parseTopPickupDates(rawValue) {
        if (rawValue && typeof rawValue === 'string' && rawValue !== 'no data') {
            return rawValue.split(',');
        }
        return [];
    }

    makeTopPickup(isoDate, roomsOtbPickups, revenuePickups, pickupsAdrs) {
        return new TopPickup(
            isoDate,
            (roomsOtbPickups[isoDate] || {}).value,
            (revenuePickups[isoDate] || {}).value,
            (pickupsAdrs[isoDate] || {}).value,
            this.hotel.locale
        );
    }

    applyTopPickupCard(card, dates, roomsOtbPickups, revenuePickups, pickupsAdrs) {
        const topPickups = [];
        for (let i = 0; i < NUM_TOPS; i++) {
            const topPickupDate = dates[i];
            if (window.infinito.vao.controller.dateHelper.isDateStr(topPickupDate)) {
                topPickups.push(this.makeTopPickup(
                    topPickupDate,
                    roomsOtbPickups,
                    revenuePickups,
                    pickupsAdrs
                ));
            }
        }
        if (card instanceof TopPickupCard) {
            card.reflow({ topPickups });
        }
    }

    fill() {
        if (
            !this.hotel
            || typeof this.hotel !== 'object'
            || !('id' in this.hotel)
            || !window.infinito.vao.controller.dateHelper.isDateStr(this.recordDate)
            || !$.isNumeric(this.pickupSetting)
        ) {
            return;
        }

        const biStatistics = window.infinito.vao.model.biStatistics;
        biStatistics.fetchStatistics(
            this.hotel.id,
            biStatistics.buildQuery({
                recordDate: this.recordDate,
                fields: [
                    biStatistics.fields.roomsOtbTopPickups,
                    biStatistics.fields.revenueTopPickups,
                    biStatistics.fields.pickupsAdrTopPickups,
                    biStatistics.fields.roomsOtbPickup,
                    biStatistics.fields.revenuePickup,
                    biStatistics.fields.pickupsAdr
                ],
                pickupOffset: this.pickupSetting
            }),
            (data, procData) => {
                const _procData = procData || {};
                const roomsOtbPickups = _procData.roomsOtbPickup || {};
                const revenuePickups = _procData.revenuePickup || {};
                const pickupsAdrs = _procData.pickupsAdr || {};

                this.applyTopPickupCard(
                    this.obtainRoomsCard(),
                    this.parseTopPickupDates((_procData.roomsOtbTopPickups || {}).value),
                    roomsOtbPickups,
                    revenuePickups,
                    pickupsAdrs
                );
                this.applyTopPickupCard(
                    this.obtainRevenueCard(),
                    this.parseTopPickupDates((_procData.revenueTopPickups || {}).value),
                    roomsOtbPickups,
                    revenuePickups,
                    pickupsAdrs
                );
                this.applyTopPickupCard(
                    this.obtainAdrCard(),
                    this.parseTopPickupDates((_procData.pickupsAdrTopPickups || {}).value),
                    roomsOtbPickups,
                    revenuePickups,
                    pickupsAdrs
                );
            }
        );
    }

    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.fill();
    }

    updated(_changedProperties) {
        super.updated(_changedProperties);
        this.colorArray = (new ColorArray());
    }

    obtainCard(name) {
        let card = this.topPickupCards.find(topPickupCard => {
            return topPickupCard instanceof TopPickupCard && topPickupCard.name === name;
        });
        if (!card) {
            card = new TopPickupCard({
                name: name,
                topPickup: [],
                color: this.colorArray.next().color
            });
            this.topPickupCards.push(card);
        }
        return card;
    }

    obtainRoomsCard() {
        return this.obtainCard(NAME_ROOMS);
    }

    obtainAdrCard() {
        return this.obtainCard(NAME_ADR);
    }

    obtainRevenueCard() {
        return this.obtainCard(NAME_REVENUE);
    }

    render() {
        return html`
        <div class="vao__components--topPickupHotelCardList">
            ${this.obtainRoomsCard()}
            <div class="vao__components--topPickupHotelCardList-divider"></div>
            ${this.obtainAdrCard()}
            <div class="vao__components--topPickupHotelCardList-divider"></div>
            ${this.obtainRevenueCard()}
        </div>
        `;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.TopPickupHotelCardList = TopPickupHotelCardList;
customElements.define('vao-top-pickup-hotel-card-list', TopPickupHotelCardList);
